class AnnouncementTimer {
  constructor() {
    this.wrapper = document.querySelector('.announcement-bar-wrapper');
    if (!this.wrapper) return;
    
    this.config = {
      startTime: this.wrapper.dataset.startTime || '00:00',
      endTime: this.wrapper.dataset.endTime || '13:59'
    };
    
    this.init();
  }

  init() {
    this.updateTimer();
    setInterval(() => this.updateTimer(), 1000);
  }

  parseTime(timeStr) {
    const [hours, minutes] = timeStr.split(':').map(Number);
    return { hours, minutes };
  }

  getNextTargetTime() {
    const now = new Date();
    const istTime = new Date(now.getTime() + (5.5 * 60 * 60 * 1000));
    const currentHour = istTime.getUTCHours();
    const currentMinute = istTime.getUTCMinutes();

    const startTime = this.parseTime(this.config.startTime);
    const endTime = this.parseTime(this.config.endTime);

    const todayIST = new Date(istTime);
    todayIST.setUTCHours(0, 0, 0, 0);

    const tomorrowIST = new Date(todayIST);
    tomorrowIST.setUTCDate(tomorrowIST.getUTCDate() + 1);

    const targetEnd = new Date(todayIST);
    targetEnd.setUTCHours(endTime.hours, endTime.minutes, 59, 999);

    const nextDayStart = new Date(tomorrowIST);
    nextDayStart.setUTCHours(startTime.hours, startTime.minutes, 0, 0);

    const currentTimeMinutes = currentHour * 60 + currentMinute;
    const startTimeMinutes = startTime.hours * 60 + startTime.minutes;
    const endTimeMinutes = endTime.hours * 60 + endTime.minutes;

    if (startTimeMinutes <= endTimeMinutes) {
      // Same day cycle (e.g., 14:00 to 23:59)
      if (currentTimeMinutes >= startTimeMinutes && currentTimeMinutes <= endTimeMinutes) {
        return targetEnd;
      } else {
        return nextDayStart;
      }
    } else {
      // Cross-midnight cycle (e.g., 00:00 to 13:59)
      if (currentTimeMinutes >= startTimeMinutes || currentTimeMinutes <= endTimeMinutes) {
        return targetEnd;
      } else {
        const todayStart = new Date(todayIST);
        todayStart.setUTCHours(startTime.hours, startTime.minutes, 0, 0);
        return todayStart;
      }
    }
  }

  updateTimer() {
    const now = new Date();
    const target = this.getNextTargetTime();
    const targetLocal = new Date(target.getTime() - (5.5 * 60 * 60 * 1000));
    const difference = targetLocal.getTime() - now.getTime();

    if (difference <= 0) {
      this.displayTime(0, 0, 0, 0);
      return;
    }

    const days = Math.floor(difference / (1000 * 60 * 60 * 24));
    const hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((difference % (1000 * 60)) / 1000);

    this.displayTime(days, hours, minutes, seconds);
  }

  displayTime(days, hours, minutes, seconds) {
    const pad = (num) => num.toString().padStart(2, '0');
    
    const daysEl = document.getElementById('days');
    const hoursEl = document.getElementById('hours');
    const minutesEl = document.getElementById('minutes');
    const secondsEl = document.getElementById('seconds');

    if (daysEl) daysEl.textContent = pad(days);
    if (hoursEl) hoursEl.textContent = pad(hours);
    if (minutesEl) minutesEl.textContent = pad(minutes);
    if (secondsEl) secondsEl.textContent = pad(seconds);
  }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  new AnnouncementTimer();
});
